import { gate } from 'hub-http/gates';
import { useHasGate } from './useHasGate';
import { VIEWS_NAMESPACE_NONE } from '../../viewsSearch/constants';
const VIEWS_V2_GATE = gate('CRM:Datasets:ViewsV2');
const VIEWS_V2_WITHOUT_ROLES_GATE = gate('CRM:Datasets:PermissionModalsWithoutRoles');
export const useHasViewsV2Gate = () => {
  const {
    loading,
    data
  } = useHasGate(VIEWS_V2_GATE);
  return !loading && Boolean(data);
};
export const useHasViewsV2 = namespaceName => {
  const hasGate = useHasViewsV2Gate();
  return hasGate && namespaceName === VIEWS_NAMESPACE_NONE;
};
export const useHasViewsV2WithoutRolesGate = () => {
  const {
    loading,
    data
  } = useHasGate(VIEWS_V2_WITHOUT_ROLES_GATE);
  return !loading && Boolean(data);
};

/**
 * Early-access: portals on the without-roles gate (but not full Views V2) see
 * the V2 modal with read-only Owner/Visitor tags instead of role selectors.
 */
export const useHasViewsV2WithoutRoles = namespaceName => {
  const hasGate = useHasViewsV2WithoutRolesGate();
  return hasGate && namespaceName === VIEWS_NAMESPACE_NONE;
};